
export default function DownloadIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12.1 15.4v-12m2.9 9.1-2.9 3-2.9-3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.8 8.1h.9c2 0 3.7 1.7 3.7 3.7v4.9c0 2-1.7 3.7-3.7 3.7H6.6c-2 0-3.7-1.7-3.7-3.7v-4.9c0-2 1.6-3.7 3.6-3.7h1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}